import { Fragment, useState } from 'react';
import { getDataUTC, is3CatInfoVerificacio } from '@portal-internet/core';
import { getDirecte } from 'utils/canals';
import { getdataFormatadaBy } from 'utils/3catinfo/dateHelper';
import { useViewport } from 'hooks/3catinfo/useViewport';
import Enllac from 'components/3catinfo/Enllac';
import Imatge from 'components/3catinfo/Imatge';
import Etiqueta from 'components/3catinfo/Etiqueta';
import Etiquetes from 'components/3catinfo/Etiquetes';
import EtiquetesEspecial from 'components/3catinfo/EtiquetesEspecial';
import Players from 'components/3catinfo/Players';
import clsx from 'clsx';
import __get from 'lodash/get';
import __isEmpty from 'lodash/isEmpty';
import styles from './destacatvisualcolumna.module.scss';

const DataPublicacio = (props) => {
    const { mostrarData, date } = props;
    return mostrarData && date ? (
        <time dateTime={getDataUTC(date)} className={styles.dataDestacat}>
            {getdataFormatadaBy(date, '.')}
        </time>
    ) : (
        <></>
    );
};

const MediaDestacat = (props) => {
    const { item, priorityImage, numColumnsRow = 0, isVideoDestacat } = props;

    const { imatges, canals_directes_embedats, videos, mediadestacats } = item || props;
    const [videoActive, setVideoActive] = useState(true);

    const pushMediaModel = (mediaModel) => {
        const duradaMediaModel =
            __get(mediaModel, 'attributes.informacio.attributes.arafem.attributes.durada.text') ||
            __get(mediaModel, 'attributes.informacio.attributes.arafem.durada.text');
        const geoBlocked = __get(mediaModel, 'attributes.geoblocked');
        setVideoActive(duradaMediaModel !== '' && !geoBlocked);
    };

    const videoAnimat = mediadestacats?.[0]?.videos?.[0]?.document;
    const mediaIdName = String(mediadestacats?.[0]?.idName || '').toUpperCase();
    if (videoAnimat && mediaIdName === 'MP4') {
        const video = `https://statics.3cat.cat/multimedia/${videoAnimat}`;
        return (
            <div className={styles.mediaVideo} data-testid='destacat-video-animat'>
                <Players tipus='videoAnimat' urlMp4={video} estil='destacatVisual' estilFormatVideo='format169' />
            </div>
        );
    }

    if (isVideoDestacat && !__isEmpty(canals_directes_embedats) && videoActive) {
        const autoplayBool = String(autoplay).toLowerCase() === 'true';
        return (
            <div className={styles.mediaVideo} data-testid='destacat-video-directe'>
                <Players
                    id={getDirecte(canals_directes_embedats[0])?.canal}
                    tipus='video-directe'
                    autoPlay={autoplayBool}
                    mostrarBotonsAccessibilitat={false}
                    eliminarPrimerTabIndex={true}
                    pushMediaModel={pushMediaModel}
                    imatges={imatges}
                    tagIdPrefix={props.redlAuxInfo?.replaceAll('|', '-')?.toLowerCase() || 'destacat-visual-columna'}
                />
            </div>
        );
    } else if (isVideoDestacat && !__isEmpty(videos) && videoActive) {
        return (
            <Players
                id={videos[0].id}
                tipus='destacat'
                imatges={imatges}
                numColumnsRow={numColumnsRow}
                priorityImage={priorityImage}
                estil='visual'
                testId='noticia-media-video'
            />
        );
    } else {
        return (
            <span className={styles.imatgeSpan}>
                <Imatge
                    imatges={imatges}
                    tipus='web_destacat'
                    alt=''
                    aria-hidden='true'
                    layout='fill'
                    objectFit='cover'
                    priority={priorityImage}
                    crop='1903'
                    data_testid='destacat-img'
                    className={!videoActive ? styles.imgNoVideo : ''}
                />
            </span>
        );
    }
};

const DestacatVisual = (props) => {
    const {
        item,
        routePath,
        testId,
        estil,
        tema,
        mostrarData,
        marcatgeAudienciesClick,
        playerEmbedat = false,
        etiquetaEspecial = false
    } = props;
    const {
        id,
        titol,
        permatitle,
        imatges,
        tipologia,
        data_publicacio,
        agrupacions,
        tags,
        domini,
        autors,
        lloc,
        videos,
        canals_directes_embedats,
        mediadestacats
    } = item || props;
    const playerEmbedatBool = String(playerEmbedat).toLowerCase() === 'true';
    const etiquetaEspecialBool = String(etiquetaEspecial).toLowerCase() === 'true';
    const route = { slug: permatitle || titol, id: id, tipologia: tipologia, type: routePath, domini };
    const hasVideoAnimat =
        !!mediadestacats?.[0]?.videos?.[0]?.document && String(mediadestacats?.[0]?.idName || '').toUpperCase() === 'MP4';
    const isVideoDestacat = playerEmbedatBool && (!__isEmpty(videos) || !__isEmpty(canals_directes_embedats));
    const isVerifica = is3CatInfoVerificacio(tags);
    const { zoomNavigator } = useViewport();
    const styleWrapper = clsx({
        [styles.imatgeWrapper]: true,
        [styles[estil]]: !!estil,
        [styles[tema]]: !!tema
    });

    const stylesDestacat = clsx({
        [styles.destacatObertura]: true,
        [styles.videoDestacat]: isVideoDestacat,
        [styles.videoAnimatDestacat]: hasVideoAnimat
    });

    const stylesText = clsx({
        [styles.textWrapper]: true,
        [styles.ambZoom]: zoomNavigator > 3,
        [styles.textWrapperDirecte]: (playerEmbedatBool && !__isEmpty(canals_directes_embedats)) || hasVideoAnimat
    });

    const stylesTitol = clsx({
        [styles.titol]: true,
        [styles.noMargin]: __isEmpty(autors) && __isEmpty(lloc)
    });

    if (!titol) {
        return <></>;
    }

    return (
        <div className={stylesDestacat} {...(testId && { 'data-testid': testId })} role='article'>
            <article className={styles.cos}>
                <div className={styles.blurredimatge} aria-hidden='true'>
                    <Imatge
                        imatges={imatges}
                        tipus='web_destacat'
                        alt=''
                        aria-hidden='true'
                        layout='fill'
                        objectFit='cover'
                        crop='1903'
                        data_testid='destacat-img'
                    />
                </div>
                <div className={styleWrapper} {...(!hasVideoAnimat && { 'data-testid': 'destacat-content-imatge' })}>
                    {etiquetaEspecialBool && (
                        <div className={styles.etiquetaEspecialWrapper}>
                            <EtiquetesEspecial agrupacions={agrupacions} tags={tags} id={id} />
                        </div>
                    )}
                    <MediaDestacat {...props} isVideoDestacat={isVideoDestacat} />
                    <div className={stylesText}>
                        {canals_directes_embedats ? (
                            <Etiqueta
                                className={styles.labelDirecte}
                                text='En directe'
                                icona='directes'
                                isBlanc={true}
                                tipus='highlight'
                            />
                        ) : (
                            <div className={styles.labelWrapper} data-testid='etiqueta'>
                                <Etiquetes agrupacions={agrupacions} tags={tags} id={id} />
                            </div>
                        )}
                        {isVerifica && <div className={styles.avantitol}>3catinfo verifica</div>}
                        <h3 className={stylesTitol} data-testid='destacat-titol'>
                            <Enllac className={styles.enllac} route={route} marcatgeAudienciesClick={marcatgeAudienciesClick}>
                                <span dangerouslySetInnerHTML={{ __html: titol }}></span>
                            </Enllac>
                        </h3>
                        {(!__isEmpty(autors) || !__isEmpty(lloc)) && (
                            <div className={styles.autorWrapper}>
                                {!__isEmpty(autors) && (
                                    <span className={styles.autors}>
                                        {autors.map((item, i) => {
                                            const isFirst = i === 0 && autors.length > 1;
                                            const isLast = i === autors.length - 1;
                                            const routeAutor = {
                                                slug: item?.nom,
                                                id: item?.id,
                                                tipologia: item?.tipologia
                                            };
                                            return (
                                                <Fragment key={'autor-' + item.id}>
                                                    {!isLast && !isFirst && ', '}
                                                    {isLast && autors.length > 1 && ' i '}
                                                    <Enllac route={routeAutor} className={styles.enllacAutor}>
                                                        {item.nom}
                                                    </Enllac>
                                                </Fragment>
                                            );
                                        })}
                                    </span>
                                )}
                                {!__isEmpty(lloc) && <span className={styles.lloc}>{lloc}</span>}
                            </div>
                        )}
                    </div>
                </div>
                <DataPublicacio mostrarData={mostrarData} date={data_publicacio} />
            </article>
        </div>
    );
};

export default DestacatVisual;
